import React from "react";

function Jobs () {
    return (
         <div className="section">
         <h2>Experience</h2>
            <div className="jobs-item">
                <div className="flex"><h3>Shopify Web Developer</h3> <p>Tampa, FL</p></div>
                <p className="date">April 2024  &#8211; Present</p>
                <ul>
                    <li>Designed and implemented the current Shopify website from scratch, ensuring a seamless and responsive user experience across all devices.</li>
                    <li>Created and integrated custom functionalities using Liquid, Shopify's templating language, to meet specific business needs.</li>
                    <li>Optimized the website layout and features to improve navigation, increase engagement, and drive conversions.</li>
                    <li>styled Shopify theme and sections to align with the company’s branding and marketing goals.</li>
                    Implemented performance optimizations, including faster load times and scalable solutions for future updates.
                </ul>
            </div>

            <div className="jobs-item">
                <div className="flex"><h3>USF Software Engineering Bootcamp</h3> <p>Tampa, FL</p></div>
                <p className="date">October 2023  &#8211; May 2024</p>
                <ul>
                    <li>Completed an intensive software engineering bootcamp focused on full-stack development.</li>
                    <li>Gained hands-on experience with Python, Node.js, React, and other industry-standard tools and frameworks.</li>
                    <li>Built and deployed full-stack applications, showcasing skills in both front-end and back-end development.</li>
                    <li>Collaborated on team projects, applying Agile methodologies and version control (Git/GitHub) to deliver functional, user-focused solutions.</li>
                    <li>Honed skills in debugging, troubleshooting, and optimizing code for performance and scalability.</li>
                </ul>
            </div>

            <div className="jobs-item">
                <div className="flex"><h3>Internet Technician</h3> <p>Clearwater, FL</p></div>
                <p className="date">June 2022  &#8211; April 2024</p>
                <ul>
                    <li>Provide clients with smooth process from sale to launch of a marketing campaign across Google and Facebook advertisements; having managed twenty marketing campaigns at once.</li>
                    <li>Work in web development team to code websites using HTML, CSS, JavaScript, and PHP for WordPress or standalone websites.</li>
                    <li>Performed code review, debugging, and unit testing on numerous lines of code to ensure adherence to modern practices and software design trends.</li>
                    <li>Collaborated with a team of designers and customers to produce mock designs for websites and online advertising.</li>
                    <li>Organization of 1000+ graphics files to ensure ease of access across business.</li>
                </ul>
            </div>
         </div>
    )
}

export default Jobs;